import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { baseUrl } from '../../constants';

@Injectable({ providedIn: 'root' })
export class MeetingsService {
  private apiUrl = `${baseUrl}Meetings`;

  constructor(private http: HttpClient) {}

  private get headers() {
    const token = localStorage.getItem('token');
    return {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      })
    };
  }

  getMine(month?: Date): Observable<any[]> {
    let params = new HttpParams();
    if (month) {
      params = params.set('month', month.toISOString());
    }
    return this.http.get<any[]>(`${this.apiUrl}/mine`, { ...this.headers, params });
  }

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`, this.headers);
  }

  getChat(id: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/${id}/chat`, this.headers);
  }

  addChat(id: number, payload: { message: string }): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/${id}/chat`, payload, this.headers);
  }

  getStaffOptions(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/staff-options`, this.headers);
  }

  create(payload: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, payload, this.headers);
  }

  update(id: number, payload: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, payload, this.headers);
  }
}
